import { useContext } from 'react';
import { CustomTableData } from "common";
import { Button } from '@mui/material'
import { Edit3, Info, Trash2 } from 'react-feather'
import { TooltipInformation } from 'common';
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'
import { MenuOptions } from './Dropdown';

export const LegalCreditsTable = ({useFetchInit}) => {

  const {
    FetchData, 
    Actions,
    globalStates
  }= useFetchInit


  const {fetchAllCredits:{credits}} = FetchData

  const {handleClickFetchInfoApplication} = Actions

  
  const columnConfig = [
    {
      headerName: 'info',
      maxWidth: 80,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      cellRenderer: (params) => {

        const {
          idcredito,
          usuario_creo,
          fecha_creo,
          usuario_modifico,
          fecha_modifico,
        } = params.data;
        
        return <TooltipInformation
          idregistro={idcredito}
          usuario_creo={usuario_creo}
          fecha_creo={fecha_creo}
          usuario_modifico={usuario_modifico}
          fecha_modifico={fecha_modifico}
        />
      },
    },
    { field: "contrato_codigo", headerName: "IDENTIFICADOR", minWidth: 140 },
    { field: "datos_cliente", headerName: "DATOS DEL CLIENTE", minWidth: 270, filter: true },
    { field: "tipo_cuota", headerName: "TIPO DE CUOTA", minWidth: 200, filter: true },
    { field: "plazo", headerName: "PLAZO", minWidth: 80, filter: true },
    { field: "saldo_financiar", headerName: "FINANCIAMIENTO", minWidth: 170, filter: true },
    {
      headerName: "ESTADO",
      field: "vigencia_check",
      minWidth: 240,
      maxWidth: 240,
      filter: true,
      cellClass: (params) => {
        if(params.value === 'VIGENTE') return 'bg-success';
        if(params.value === 'FINALIZACION ORDINARIA') return 'bg-info';
        if(params.value === 'CREDITO INCOBRABLE') return 'bg-danger';
        if(params.value === 'FINALIZACION JUDICIAL') return 'bg-info';
        if(params.value === 'FINALIZACION EXTRAORDINARIA') return 'bg-info';
        if(params.value === 'COBRO EXTRAJUDICIAL') return 'bg-warning';
        if(params.value === 'COBRO JUDICIAL') return 'bg-danger';
      },
    },
    {
      headerName: "OPCIONES",
      minWidth: 440,
      cellRenderer: (params) => {

        const {idcredito, idcotizacion, idvehiculo, aprobacion_check} = params.data

        return <>
          <Button 
              startIcon = { <Info/>}
              variant='contained'
              size='small' 
              color='info'
              sx={{ marginRight: '8px' }}
              onClick={() => handleClickFetchInfoApplication(idcredito, idcotizacion,idvehiculo, 'READONLY')} 
              style={ { width: 150 } }
              > 
              Informacion
          </Button>
          <MenuOptions params={params} Actions={Actions}/>
          
        </>

      },
    },
  ];
  return (
    <>
      <CustomTableData
        rowConfig={credits}
        // rowConfig={[]}
        columnConfig={columnConfig} />
    </>
  );
};
